import React, { useState } from "react"

import Popup from "components/Ui/Popup"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import { DeactivateButton as UnpublishButton } from "./PublishWorkflow.styled"

type Props = {
  isPublished: boolean
  onPublish: () => void
  onUnpublish: () => void
  loading: boolean
  hasDraft?: boolean
  draftRevision?: number
}

const PublishWorkflow = ({
  isPublished,
  onPublish,
  onUnpublish,
  loading,
  hasDraft,
  draftRevision
}: Props) => {
  const [openPopup, setOpenPopup] = useState<"publish" | "unpublish" | null>(null)

  if (isPublished && hasDraft) {
    return (
      <>
        <PrimaryButton handleClick={() => setOpenPopup("publish")}>
          Publish v{draftRevision}
        </PrimaryButton>
        <UnpublishButton type="button" onClick={() => setOpenPopup("unpublish")}>
          Unpublish
        </UnpublishButton>
        {openPopup === "publish" && (
          <Popup
            title="Publish new version"
            subtitle={`This will publish revision ${draftRevision} and replace the currently published version.`}
            handleCloseClick={(e) => {
              e.stopPropagation()
              setOpenPopup(null)
            }}
            handleOkClick={(e) => {
              e.stopPropagation()
              onPublish()
              setOpenPopup(null)
            }}
            buttonText="Yes, publish"
            loading={loading}
          />
        )}
        {openPopup === "unpublish" && (
          <Popup
            title="Unpublish workflow"
            subtitle="Are you sure you want to unpublish this workflow? It will stop processing new orders."
            handleCloseClick={(e) => {
              e.stopPropagation()
              setOpenPopup(null)
            }}
            handleOkClick={(e) => {
              e.stopPropagation()
              onUnpublish()
              setOpenPopup(null)
            }}
            buttonText="Yes, unpublish"
            loading={loading}
          />
        )}
      </>
    )
  }

  if (isPublished) {
    return (
      <>
        <UnpublishButton type="button" onClick={() => setOpenPopup("unpublish")}>
          Unpublish
        </UnpublishButton>
        {openPopup === "unpublish" && (
          <Popup
            title="Unpublish workflow"
            subtitle="Are you sure you want to unpublish this workflow? It will stop processing new orders."
            handleCloseClick={(e) => {
              e.stopPropagation()
              setOpenPopup(null)
            }}
            handleOkClick={(e) => {
              e.stopPropagation()
              onUnpublish()
              setOpenPopup(null)
            }}
            buttonText="Yes, unpublish"
            loading={loading}
          />
        )}
      </>
    )
  }

  return (
    <>
      <PrimaryButton handleClick={() => setOpenPopup("publish")}>
        Publish
      </PrimaryButton>
      {openPopup === "publish" && (
        <Popup
          title="Publish workflow"
          subtitle="Publishing will activate this workflow. It will start processing new orders immediately."
          handleCloseClick={(e) => {
            e.stopPropagation()
            setOpenPopup(null)
          }}
          handleOkClick={(e) => {
            e.stopPropagation()
            onPublish()
            setOpenPopup(null)
          }}
          buttonText="Yes, publish"
          loading={loading}
        />
      )}
    </>
  )
}

export default PublishWorkflow
